import { css } from '@linaria/atomic';

export const skeletonRowStyles = css`
  display: flex;
  align-items: center;
  gap: var(--fabric-number-n-2-px);
  padding: var(--fabric-number-n-1-px) var(--fabric-number-n-2-px);
  width: 100%;
`;

export const skeletonTextContainerStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--fabric-number-n-1-px);
  flex: 1;
  min-width: 0;
`;
